import type { UIEvent } from 'react';
import type { SocialMediaAndApps, UtilLinks } from 'core/domains';

export type AccordionProps = {
  title?: string;
  children: ReactNode;
};

export type UtilLinksProps = {
  data?: UtilLinks[];
};

export type SocialProps = {
  data?: SocialMediaAndApps;
};

export enum FOOTER_CONST {
  TEST_ID = 'footer',
}
